import React, { useCallback, useState } from "react";
import AddButtonMenu from "../AddButtonMenu";
import ModelDataMenu from "../ModelDataMenu";
import { useChatOpen, useSharedChat } from "../../hooks/useAgentContext";
import type {
  TreeItem,
  Tree,
  ScenarioState,
  UserRights,
  Variant,
  SnackBarContent,
} from "./types";
import VariantStyles from "./VariantStyles";

interface TreeItemActionsProps {
  item: TreeItem;
  tree: Tree;
  variant: Variant;
  level: number;
  scenarioId: number;
  currentState: ScenarioState;
  reloadState: () => void;
  userRights: UserRights;
  setSelected: (item: TreeItem | null) => void;
  setEditing: (editing: boolean) => void;
  setContextSnackBarContent: (content: SnackBarContent) => void;
  allowedTypes?: Set<string> | null;
}

export default function TreeItemActions({
  item,
  tree,
  variant,
  level,
  scenarioId,
  currentState,
  reloadState,
  userRights,
  setSelected,
  setEditing,
  setContextSnackBarContent,
  allowedTypes,
}: TreeItemActionsProps) {
  const recreateExcelInputIfSync = () => {};
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { setIsChatOpen } = useChatOpen();
  const { sendMessage } = useSharedChat();

  const handleMenuOpenChange = useCallback((open: boolean) => {
    setIsMenuOpen(open);
  }, []);

  const handleDocumentation = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setIsChatOpen(true);
    sendMessage(`Explain me what is the block named '${item.name}' (type: ${item.type}) and how to use it ?`);
  }, [setIsChatOpen, sendMessage, item.name, item.type]);

  return (
    <div
      className={
        Boolean(item.anchorEl) || isMenuOpen
          ? "datagroup-visible"
          : "datagroup-component-icons"
      }
    >
      <div className="flex items-center">
        {userRights.right_to_write && (
          <AddButtonMenu
            item={item}
            tree={tree}
            reloadState={reloadState}
            bgcolor={VariantStyles[variant]["bgcolor"][level]}
            scenario_id={scenarioId}
            recreateExcelInputIfSync={recreateExcelInputIfSync}
            level={level}
            currentState={currentState}
            allowedTypes={allowedTypes}
          />
        )}

        <button
          className="p-1 ml-0.5 text-inherit"
          title="Documentation"
          onClick={handleDocumentation}
        >
          <span className="material-symbols-outlined text-[20px]">help_outline</span>
        </button>

        {item.kind === "Input" && (
          <ModelDataMenu
            item={item}
            tree={tree}
            bgcolor={VariantStyles[variant]["bgcolor"][level]}
            scenario_id={scenarioId}
            level={level}
            currentState={currentState}
            userRights={userRights}
            setSelected={setSelected}
            setEditing={setEditing}
            setContextSnackBarContent={setContextSnackBarContent}
            onMenuOpenChange={handleMenuOpenChange}
          />
        )}
      </div>
    </div>
  );
}
